import React from 'react';
import { Card, Badge } from './ui';
import { Book, BookOpen, BookMarked, Gift } from 'lucide-react';
export function Product() {
  const tomos = [{
    icon: <Book className="w-8 h-8 text-teal-600" data-id="element-77" data-mp="1udlxyt3b20z7" />,
    color: 'bg-teal-50 border-teal-200',
    title: 'TOMO 1 — ENTENDÉ Y MEJORÁ SU CONDUCTA',
    subtitle: 'Primero entendé. Después actuá.',
    desc: 'Descubrí qué hay detrás de los gritos, la desobediencia y las conductas que se repiten. Aprendé a identificar patrones y a saber cómo actuar en cada situación sin improvisar.'
  }, {
    icon: <BookOpen className="w-8 h-8 text-coral-500" data-id="element-78" data-mp="2d8khm76niw4r" />,
    color: 'bg-coral-50 border-coral-100',
    title: 'TOMO 2 — LÍMITES, RABIETAS Y EMOCIONES',
    subtitle: 'Acompañar una emoción no significa eliminar el límite.',
    desc: 'Aprendé qué hacer cuando aparece un ‘NO’, una rabieta o una explosión emocional. Herramientas para mantener el límite, acompañar la emoción y evitar que todo termine en una pelea.'
  }, {
    icon: <BookMarked className="w-8 h-8 text-amber-600" data-id="element-79" data-mp="1vkyscu7gmqs0" />,
    color: 'bg-amber-50 border-amber-200',
    title: 'TOMO 3 — RUTINAS Y PLAN DE CONDUCTA',
    subtitle: 'Menos improvisación. Más previsibilidad.',
    desc: 'Convertí momentos como guardar juguetes, bañarse, vestirse o ir a dormir en rutinas más claras. Creá un plan práctico para que tu hijo sepa qué esperar y vos sepas cómo actuar.'
  }];
  return <section className="relative px-4 py-9 bg-gradient-to-b from-cream-100 to-cream-50 overflow-hidden" data-id="element-80" data-mp="2eii6udcot1lt">
      <div className="absolute -top-16 left-1/2 -translate-x-1/2 w-[600px] h-[240px] bg-teal-500/10 blur-[100px] rounded-full pointer-events-none" aria-hidden="true" data-id="element-81" data-mp="2jg9zj9l5orr2"></div>
      <div className="relative z-10 max-w-5xl mx-auto" data-id="element-82" data-mp="2t7ea7x3stqg3">
        <div className="text-center mb-7" data-id="element-83" data-mp="2xa17idj8o3ko">
          <Badge variant="success" className="mb-4" data-id="element-84" data-mp="2xbccuhsc1jdw">
            🧩 PUNTO DIGITAL™ — KIT DE CONDUCTA INFANTIL
          </Badge>
          <h2 className="text-[30px] md:text-5xl font-black text-navy tracking-tight leading-tight mb-3" data-id="element-85" data-mp="126cnzxlr76cz">
            3 Tomos <span className="text-teal-500" data-id="element-86" data-mp="y5184jsolzhz">+ 5 Bonos</span>
          </h2>
          <p className="text-base sm:text-lg text-ink-muted max-w-2xl mx-auto leading-snug" data-id="element-87" data-mp="y2y6t3m2wjxy">
            Un sistema práctico para dejar de improvisar frente a cada conducta
            difícil
          </p>
          <div className="flex flex-wrap justify-center gap-2 mt-5 text-sm font-medium text-teal-600" data-id="element-88" data-mp="173moq9elf4g4">
            <span data-id="element-89" data-mp="1gv948hxyrpoo">Entendé</span> <span className="text-ink-faint" data-id="element-90" data-mp="1gvsedchdh9s5">→</span>
            <span data-id="element-91" data-mp="1guzaqkdpn0e8">Acompañá</span> <span className="text-ink-faint" data-id="element-92" data-mp="1uv1s85i3vrsy">→</span>
            <span data-id="element-93" data-mp="1utqr6dg1oy5j">Poné límites</span> <span className="text-ink-faint" data-id="element-94" data-mp="1usxqnu7oj4vu">→</span>
            <span data-id="element-95" data-mp="1pvp83simcyu2">Organizá</span> <span className="text-ink-faint" data-id="element-96" data-mp="1px8mteomn1tq">→</span>
            <span data-id="element-97" data-mp="gr3ry5faznp">Aplicá</span>
          </div>
        </div>

        <div className="mb-8" data-id="element-98" data-mp="h99dldz6q8a">
          <h3 className="text-2xl md:text-3xl font-black text-navy tracking-tight mb-4 flex items-center gap-3" data-id="element-99" data-mp="3rnbrb7w9rpfz">
            <span className="text-3xl" data-id="element-100" data-mp="274rffjyche4w">🧩</span> 3 TOMOS COMPLETOS
          </h3>
          <div className="grid md:grid-cols-2 gap-4" data-id="element-101" data-mp="2c4cqutupbeyi">
            {tomos.map((tomo, i) => <Card key={i} className={`border p-5 md:p-6 shadow-[0_4px_16px_-10px_rgba(16,42,67,0.25)] ${tomo.color}`} data-id="element-102" data-mp="2c670vd4fpmnt" data-mpi={i}>
                <div className="flex items-start gap-4" data-id="element-103" data-mp="22czze3cteqt0">
                  <div className="p-3 bg-white rounded-xl shrink-0" data-id="element-104" data-mp="1oe8n8mhijf7i">
                    {tomo.icon}
                  </div>
                  <div data-id="element-105" data-mp="1teo07cxvukoy">
                    <h4 className="font-bold text-navy text-lg mb-1" data-id="element-106" data-mp="1tf61inzejp3q">
                      {tomo.title}
                    </h4>
                    <p className="text-teal-600 text-sm font-medium mb-3" data-id="element-107" data-mp="1jfox09vvzh9c">
                      {tomo.subtitle}
                    </p>
                    <p className="text-ink-muted text-sm leading-relaxed" data-id="element-108" data-mp="39t6303dwbmt3">
                      {tomo.desc}
                    </p>
                  </div>
                </div>
              </Card>)}
          </div>
        </div>

        <Card className="bg-white px-5 py-4 md:px-6 md:py-5" data-id="element-109" data-mp="2p0zdsz0nbyid">
          <h4 className="font-bold text-lg text-teal-600 mb-3 text-center" data-id="element-110" data-mp="2k5aemwsjgjml">
            Cada tomo incluye:
          </h4>
          <ul className="w-fit mx-auto grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-1.5" data-id="element-111" data-mp="2f31jbts715hb">
            {['Herramientas para situaciones reales', 'Ejemplos claros de cómo actuar', 'Estrategias para rabietas y límites', 'Rutinas simples y aplicables', 'Recursos para usar desde el primer día'].map((item, i) => <li key={i} className="flex items-start gap-2" data-id="element-112" data-mp="1weo48yv2an9f" data-mpi={i}>
                <span className="text-base leading-snug shrink-0" aria-hidden="true" data-id="element-113" data-mp="1rg36r7772hoo">
                  ✅
                </span>
                <span className="text-ink-muted leading-snug" data-id="element-114" data-mp="1ie3mm60vuxhi">{item}</span>
              </li>)}
          </ul>
        </Card>
      </div>
    </section>;
}
export function Bonuses() {
  const bonuses = [{
    title: 'TABLA DE RECOMPENSAS',
    desc: 'Una herramienta visual para definir pequeños objetivos, acompañar hábitos y responsabilidades y reconocer avances.',
    value: 'USD 7.00'
  }, {
    title: 'REGISTRO DE CONDUCTA',
    desc: 'Registrá qué pasó antes, durante y después de determinadas situaciones para empezar a identificar patrones que pueden pasar desapercibidos.',
    value: 'USD 7.00'
  }, {
    title: 'TARJETAS DE EMOCIONES',
    desc: 'Un apoyo visual para ayudar al niño a identificar, nombrar y expresar diferentes emociones cuando todavía le cuesta poner en palabras lo que siente.',
    value: 'USD 7.00'
  }, {
    title: 'PACK DE RUTINAS VISUALES',
    desc: 'Recursos visuales para hacer más predecibles momentos como vestirse, ordenar, bañarse, hacer tareas o prepararse para dormir. Menos repetir, más claridad sobre qué toca hacer y qué viene después.',
    value: 'USD 8.00'
  }, {
    title: 'ACUERDO FAMILIAR DE CONDUCTA',
    desc: 'Una herramienta para establecer reglas, responsabilidades y acuerdos familiares de manera más clara y consistente.',
    value: 'USD 8.00'
  }];
  return <section className="relative py-10 px-4 bg-navy overflow-hidden" data-id="element-115" data-mp="2tc3q71d8ik63">
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[720px] h-[320px] bg-teal-500/10 blur-[120px] rounded-full pointer-events-none" aria-hidden="true" data-id="element-116" data-mp="25n17dq6v6la0"></div>
      <div className="relative z-10 max-w-5xl mx-auto" data-id="element-117" data-mp="21nsf6prh2vgk">
        <div className="text-center mb-7" data-id="element-118" data-mp="2fm05ieu06yir">
          <h2 className="text-[30px] md:text-5xl font-black text-white tracking-tight leading-none flex items-center justify-center gap-3" data-id="element-119" data-mp="2am41wgp7x93q">
            <Gift className="w-8 h-8 md:w-10 md:h-10 text-teal-400" data-id="element-120" data-mp="3qzb1p9jm17ht" />5 BONOS
            PRÁCTICOS
          </h2>
          <p className="text-sm md:text-base text-teal-300 font-bold uppercase tracking-[0.25em] mt-3" data-id="element-121" data-mp="3m0hmncood8fj">
            Siempre incluidos
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-6 gap-3 md:gap-4 mb-7" data-id="element-122" data-mp="1cscrwoow8vur">
          {bonuses.map((bono, i) => <div key={i} className={`flex flex-col rounded-2xl border border-teal-500/40 bg-[#0A1A2B] p-4 sm:p-5 shadow-[0_16px_36px_-26px_rgba(0,0,0,0.9)] transition-colors hover:border-teal-400 md:col-span-2 ${i === 3 ? 'md:col-start-2' : ''}`} data-id="element-123" data-mp="ytlg58xi7m9s" data-mpi={i}>
              <p className="text-3xl sm:text-4xl font-black text-teal-400 leading-none tabular-nums" data-id="element-124" data-mp="1viktv3guxg9d">
                {String(i + 1).padStart(2, '0')}
              </p>
              <p className="text-[10px] font-bold uppercase tracking-[0.2em] text-teal-300 mt-1.5" data-id="element-125" data-mp="1mpzd1swsdjn6">
                🎁 BONO {i + 1}
              </p>
              <h4 className="font-bold text-white text-base sm:text-lg leading-snug mt-2" data-id="element-126" data-mp="2aea6ib05kh1f">
                {bono.title}
              </h4>
              <p className="text-white/60 text-[13px] leading-snug mt-1.5" data-id="element-127" data-mp="f5c6gxdbtbem">
                {bono.desc}
              </p>
              <div className="mt-auto pt-3 border-t border-white/10 flex items-center justify-between gap-2 mt-3" data-id="element-128" data-mp="ad2i3lrv0jeg">
                <span className="line-through text-white/40 text-xs" data-id="element-129" data-mp="5fk7lqy71w4c">
                  Valor {bono.value}
                </span>
                <span className="bg-teal-500 text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-130" data-mp="e3am6itytt1">
                  GRATIS
                </span>
              </div>
            </div>)}
        </div>

        <div className="bg-[#0A1A2B] border border-teal-500/40 rounded-2xl p-6 text-center max-w-2xl mx-auto shadow-[0_18px_40px_-24px_rgba(0,0,0,0.9)]" data-id="element-131" data-mp="o5ie42mcfh5v">
          <p className="text-white/60 text-sm uppercase tracking-widest mb-1" data-id="element-132" data-mp="k3dodez0n4oi">
            Valor de los bonos
          </p>
          <p className="text-4xl font-black text-white mb-2 line-through decoration-coral-400/70" data-id="element-133" data-mp="38tmzktcgxq2a">
            USD 37.00
          </p>
          <p className="text-xl sm:text-2xl font-bold text-teal-400" data-id="element-134" data-mp="1kcn6ji5590lp">
            → INCLUIDOS GRATIS CON TU KIT
          </p>
        </div>

      </div>
    </section>;
}